import { render, staticRenderFns } from "./DailyChatDrawer.vue?vue&type=template&id=4e230a1f&scoped=true&"
import script from "./DailyChatDrawer.vue?vue&type=script&lang=js&"
export * from "./DailyChatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DailyChatDrawer.vue?vue&type=style&index=0&id=4e230a1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e230a1f",
  null
  
)

export default component.exports